/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FantaTeam } from '../models/FantaTeam';
import type { FantaTeamCreate } from '../models/FantaTeamCreate';
import type { FantaTeamPatch } from '../models/FantaTeamPatch';
import type { FantaTransfer } from '../models/FantaTransfer';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaTeamService {
    /**
     * Get My Fanta Teams
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static getMyFantaTeams(): CancelablePromise<Array<FantaTeam>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_team/my',
        });
    }
    /**
     * Get Fanta Team
     * @param fantaTeamId
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static getFantaTeam(
        fantaTeamId: number,
    ): CancelablePromise<FantaTeam> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_team/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Fanta Team
     * @param fantaTeamId
     * @param requestBody
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static patchFantaTeam(
        fantaTeamId: number,
        requestBody: FantaTeamPatch,
    ): CancelablePromise<FantaTeam> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/fanta_team/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Fanta Team
     * @param fantaTeamId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static deleteFantaTeam(
        fantaTeamId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/fanta_team/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Fanta Teams By User
     * @param userId
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static getFantaTeamsByUser(
        userId: number,
    ): CancelablePromise<Array<FantaTeam>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_team/user/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Fanta Team
     * @param requestBody
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static createFantaTeam(
        requestBody: FantaTeamCreate,
    ): CancelablePromise<FantaTeam> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_team/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Player To Fanta Team
     * @param fantaTeamId
     * @param playerId
     * @returns FantaTeam Successful Response
     * @throws ApiError
     */
    public static addPlayerToFantaTeam(
        fantaTeamId: number,
        playerId: number,
    ): CancelablePromise<FantaTeam> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/fanta_team/{fanta_team_id}/player/{player_id}',
            path: {
                'fanta_team_id': fantaTeamId,
                'player_id': playerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Player From Fanta Team
     * @param fantaTeamId
     * @param playerId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removePlayerFromFantaTeam(
        fantaTeamId: number,
        playerId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/fanta_team/{fanta_team_id}/player/{player_id}',
            path: {
                'fanta_team_id': fantaTeamId,
                'player_id': playerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Fanta Transfers By Team
     * @param fantaTeamId
     * @returns FantaTransfer Successful Response
     * @throws ApiError
     */
    public static getFantaTransfersByTeam(
        fantaTeamId: number,
    ): CancelablePromise<Array<FantaTransfer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_team/transfer/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Player
     * @param fantaTeamId
     * @param playerOutId
     * @param playerInId
     * @returns FantaTransfer Successful Response
     * @throws ApiError
     */
    public static transferPlayer(
        fantaTeamId: number,
        playerOutId: number,
        playerInId: number,
    ): CancelablePromise<FantaTransfer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_team/transfer/team/{fanta_team_id}/out/{player_out_id}/in/{player_in_id}',
            path: {
                'fanta_team_id': fantaTeamId,
                'player_out_id': playerOutId,
                'player_in_id': playerInId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reverse Transfer Player
     * @param fantaTransferId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static reverseTransfer(
        fantaTransferId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_team/transfer/reverse/{fanta_transfer_id}',
            path: {
                'fanta_transfer_id': fantaTransferId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
